@if (label) {
  <label
    class="text-body-regular mb-4 text-current"
    [ngClass]="{ 'text-po-error-base': hasError, '!opacity-40': disabled }"
    data-testid="label"
    [attr.for]="inputId"
  >
    {{ label }}
  </label>
}

<div class="relative h-ie w-full rounded-lg bg-white">
  @if (loading) {
    <aw-loader
      class="absolute left-0 right-0 z-50 h-full w-full"
      data-testid="contentLoader"
    >
      <svg:rect width="100%" height="64" />
    </aw-loader>
  }
  @if (placeholder) {
    <label
      class="ctrl-placeholder"
      [ngClass]="{
        'pl-5': !icon,
        'pl-11': icon,
        'ctrl-placeholder--floating': shouldPlaceholderFloat,
        'ctrl-placeholder--not-floating': !shouldPlaceholderFloat,
        '!opacity-40': disabled
      }"
      data-testid="placeholder"
      [attr.data-floating]="shouldPlaceholderFloat"
    >
      {{ placeholder }}
    </label>
  }
  @if (icon) {
    <aw-icon
      class="absolute left-5 top-[15px] block w-4 text-black"
      [ngClass]="{
        '!opacity-40': disabled
      }"
      data-testid="input-icon"
      [icon]="icon"
    />
  }
  @if (copyable) {
    <button
      class="absolute right-5 top-2.5 flex h-6 w-6"
      data-testid="copyBtn"
      type="button"
      [cdkCopyToClipboard]="value"
    >
      <aw-icon class="w-full text-black" icon="file-copy" />
    </button>
  }

  <div class="h-full w-full">
    @if(isShowDirhamIcon) {
      <aw-icon
      icon="Dirham-icon"
      class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none z-10 pt-3.5 w-3.5 h-3.5 !overflow-visible"
    ></aw-icon>
    }

  <input
    #input
    class="ctrl-border text-body-regular h-full w-full rounded-lg bg-transparent pb-0 pr-4 text-black"
    [ngClass]="[
      styleClasses,
      shouldPlaceholderFloat ? 'pt-5' : 'pt-0',
      icon ? 'pl-11' : 'pl-5',
      hasError ? 'ctrl-border--error' : '',
      disabled ? '!opacity-40' : '',
      isShowDirhamIcon ? 'pt-7 pl-8' : ''
    ]"
    data-testid="input"
    [attr.id]="inputId"
    [attr.inputmode]="inputMode"
    [attr.spellcheck]="spellcheck"
    [attr.autocomplete]="autocomplete"
    [name]="name"
    [type]="type === 'number' ? 'text' : type"
    [readonly]="readonly"
    [awNumbersOnly]="type === 'number'"
    [disabled]="disabled || readonly"
    [mask]="mask"
    [prefix]="isShowDirhamIcon ? '' : prefix"
    [suffix]="suffix"
    [thousandSeparator]="thousandSeparator"
    [showMaskTyped]="false"
    [showTemplate]="false"
    [dropSpecialCharacters]="dropSpecialCharacters"
    [ngModel]="value"
    (ngModelChange)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />

  </div>
</div>
